import { GET_PLATFORMS_SUCCESS, GET_PLATFORMS_FAILURE } from '../constants/actionTypes';

interface PlatformState {
  list: any[]; 
  pagination: object;
  error: string | null;
}

const initialState: PlatformState = {
  list: [],
  pagination: {},
  error: null,
};

const platformReducer = (state = initialState, action: { type: string; payload: any }): PlatformState => {
  switch (action.type) {
    case GET_PLATFORMS_SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: action.payload.pagination,
        error: null,
      };
    case GET_PLATFORMS_FAILURE:
      return {
        ...state,
        list: [],
        pagination: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default platformReducer;
